import { render, staticRenderFns } from "./DriblabCountryFlag.vue?vue&type=template&id=7daa65f9"
import script from "./DriblabCountryFlag.vue?vue&type=script&lang=js"
export * from "./DriblabCountryFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports